
export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-amber-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Kobby Taylor
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Multi-award-winning writer, composer, and creative director bridging theatre, TV, and music through innovative storytelling and cultural expression.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-line text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-linkedin-line text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-spotify-line text-white"></i>
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-amber-400 mb-4">Connect</h4>
            <p className="text-gray-300 leading-relaxed">
              For professional inquiries, collaborations, and booking information, please reach out on nigel@beats-bus.co.uk
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Kobby Taylor. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-300 cursor-pointer mt-4 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
